import { Typography } from "@mui/material";
import React from "react";

function NotFound({ text }) {
  return (
    <div className="GlassEffect py-5 px-5 text-center">
      <Typography variant="h6" style={{ fontWeight: "lighter" }}>
        {text}
      </Typography>
    </div>
  );
}

export default NotFound;
